import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { linkToAirthingsAfBReadme } from 'commons/src/constants';
import { Store } from '../../reducers';

const IntegrationsOverview = (): React.ReactElement => {
    const { t: txt } = useTranslation();
    const selectedGroup = useSelector((store: Store) => store.userSettings.selectedGroup);

    return (
        <div>
            <h2 className="settings__header">{txt('Integrations.Overview')}</h2>
            <div className="settings-details-container">
                <p>{txt('Integrations.Description')}</p>
                <a href={linkToAirthingsAfBReadme} target="_blank" rel="noopener noreferrer">
                    {txt('Integrations.InfoAndTechDocumentation')}
                </a>
                <p>
                    {txt('OrganizationProfile.AccountId')}
                    <span className="text-bold">{selectedGroup && selectedGroup.id}</span>
                </p>
            </div>
        </div>
    );
};

export default IntegrationsOverview;
